'use client';

import React, { useState } from 'react';
import { storyblokEditable, StoryblokComponent } from 'gatsby-source-storyblok';
import { render } from 'storyblok-rich-text-react-renderer';
import { bgColors } from '../../assets/colors';
import PlusIcon from '../atoms/icons/plus';

const TextAccordeon = ({
  blok,
  destination,
  season,
  hotel,
  isNested = false,
}) => {
  const RichText = ({ document }) => {
    return render(document, {
      defaultBlokResolver: (name, props) => {
        const blok = { ...props, component: name };
        return (
          <StoryblokComponent
            blok={blok}
            key={blok._uid}
            destination={destination}
            season={season}
            hotel={hotel}
            inTextBlock={true}
            parentColor={blok.background_color}
          />
        );
      },
    });
  };

  // TailwindCSS utility classes --- --- --- --- --->
  const backgroundColors = bgColors;

  const padding = isNested
    ? 'pt-4 px-4 md:px-8 md:pt-4 is-nested'
    : 'py-1 px-4 md:px-8 md:py-2 ';

  const widths = {
    'w-full': 'w-full col-span-12',
    'w-3/4': 'w-full col-span-12 md:col-span-9',
    'w-2/3': 'w-full col-span-12 md:col-span-8',
    'w-1/2': 'col-span-12 md:col-span-6',
    'w-1/3': 'col-span-12 md:col-span-4',
    'w-1/4': 'w-full sm:w-1/2 md:w-1/3 lg:w-1/4 col-span-6 sm:col-span-3',
    auto: 'w-fit sm:max-w-prose',
  };

  const backgroundColor =
    backgroundColors[blok.background_color] || 'bg-white/90';

  // >--- --- --- --- --- TailwindCSS utility classes

  const [visible, setVisible] = useState(false);

  return (
    blok.heading &&
    !blok.hide_on_site && (
      <div
        className={`${padding} rounded ${
          widths[blok.width]
        } ${backgroundColor} bg-yellow-15`}
        {...storyblokEditable(blok)}
      >
        <div className="flex justify-between">
          <h3 className="py-2 md:py-3">
            <button className="text-left" onClick={() => setVisible(!visible)}>
              {blok.heading}
            </button>
          </h3>
          <button
            className="no-underline opacity-100 rounded-full bg-yellow-60 hover:bg-yellow-40 w-8 h-8 ml-4 mt-0.5 md:mt-1 flex shrink-0 items-center justify-center"
            onClick={() => setVisible(!visible)}
          >
            {visible ? (
              <PlusIcon inverted={true} />
            ) : (
              <PlusIcon inverted={false} />
            )}
          </button>
        </div>
        <div className={`${visible ? 'block' : 'hidden'}`}>
          {RichText({ document: blok.text })}
        </div>
      </div>
    )
  );
};

export default TextAccordeon;
